import { useSyncExternalStore } from 'react';
import { type MessageCache, type ESACacheMessage } from '../cache/MessageCache';

const EMPTY_ARRAY: ESACacheMessage[] = [];

/**
 * React hook wrapping useSyncExternalStore for ESA message cache.
 * Returns a stable snapshot for the given threadId.
 * Returns empty array for null threadId.
 */
export function useThreadMessages(
  threadId: string | null,
  cache: MessageCache
): ESACacheMessage[] {
  return useSyncExternalStore(
    cache.subscribe.bind(cache),
    () => (threadId ? cache.getSnapshot(threadId) : EMPTY_ARRAY)
  );
}
